export default __webpack_public_path__ + "static/media/webilo-designing.27f0aaf9.svg";